import { MutationResult } from 'apollo-angular/types';

export class GraphqlMissingDataError extends Error {
    public override name = GraphqlMissingDataError.name;
    public constructor(public readonly result: MutationResult<unknown>) {
        super('The operation encountered no errors or data.');
    }
}
